var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-toasts" },
    _vm._l(_vm.toasts, function(toast) {
      return _c(
        "div",
        {
          staticClass: "toast",
          class: toast.type,
          on: {
            mouseenter: function($event) {
              return toast.stop()
            },
            mouseleave: function($event) {
              return toast.play()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "u-clear" },
            [
              _c(
                "a",
                {
                  staticClass: "u-fr close",
                  on: {
                    click: function($event) {
                      return toast.hide()
                    }
                  }
                },
                [_c("icon-close")],
                1
              ),
              _vm._v(" "),
              _c(_vm.icon[toast.type], {
                tag: "component",
                staticClass: "u-fl icon"
              }),
              _vm._v(" "),
              _c("p", { staticClass: "u-ff title" }, [
                _vm._v(_vm._s(toast.type))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "message" }, [_vm._v(_vm._s(toast.message))])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }